/** Stale acks (`seq` below pending) are ignored. A higher seq clears pending without RTT (skipped pings are OK). */
export function processHeartbeatAck(params: {
  seq: number;
  awaitingSeq: number | null;
  sentAtMs: number;
  recordRtt: (rttMs: number) => void;
}): { awaitingSeq: number | null; missed: number } {
  const { seq, awaitingSeq, sentAtMs, recordRtt } = params;
  if (awaitingSeq === null) return { awaitingSeq, missed: 0 };
  if (!Number.isFinite(seq)) return { awaitingSeq, missed: 0 };

  const ack = Math.trunc(seq);
  const pending = awaitingSeq;
  if (ack < pending) return { awaitingSeq, missed: 0 };

  if (ack === pending) {
    recordRtt(Date.now() - sentAtMs);
  }

  return { awaitingSeq: null, missed: 0 };
}
